import GuestsFields from './GuestsFields';

export default GuestsFields;
